import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { getAllNotifications } from '../../Redux/action/Customer/CustomerAction';
import { AMPMDATETIME } from '../../HelperFunctions';
import { toast } from 'react-toastify';
import axios from 'axios';
import { adminMainUrl } from '../../Config';

const Navbar = ({ CompanyDetailData, customertoken }) => {
    const [dropdown1, setDropdown1] = useState(false);
    const [notificationCount, setNotificationCount] = useState(0);
    const [loadingNotification, setLoadingNotification] = useState(false);
    const [notificationArr, setNotificationArr] = useState([]);


    const dispatch = useDispatch();


    useEffect(() => {
        if (customertoken) {
            dispatch(getAllNotifications(customertoken));
        }
    }, []);


    useEffect(() => {
        // Function to dispatch the action
        const fetchNotifications = () => {
          if (customertoken) {
            dispatch(getAllNotifications(customertoken));
          }
        };
    
        fetchNotifications();
    
        const intervalId = setInterval(fetchNotifications, 20000);
    
        return () => clearInterval(intervalId);
      }, [dispatch]);

    const refreshNotification = () => {
        if (customertoken) {
            dispatch(getAllNotifications(customertoken));
        }
    }



    const {
        loadingCustomerNotificationList,
        CustomerNotificationListError,
        CustomerNotificationList,
    } = useSelector(state => state.CustomerPanelReducer);


    useEffect(() => {
        if (CustomerNotificationList) {
            let arr = [];
            CustomerNotificationList.map(v => arr.push(v));
            setNotificationArr(arr);
            setNotificationCount(arr.length)
        }
    }, [CustomerNotificationList])
    useEffect(() => {
        if (loadingCustomerNotificationList) {
            setLoadingNotification(true);
        } else {
            setLoadingNotification(false);
        }
    }, [loadingCustomerNotificationList])

    const navigate = useNavigate();
    const handleLogout = () => {
        // Trigger SweetAlert
        Swal.fire({
            title: 'Are you sure?',
            text: "You will be logged out!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, log out!'
        }).then((result) => {
            if (result.isConfirmed) {
                // If user confirms, remove the token and navigate to login
                Cookies.remove('customertoken');
                navigate('/customer/login');
                Swal.fire(
                    'Logged Out!',
                    'You have been logged out successfully.',
                    'success'
                );
            }
        });
    };

    let config = {
        headers: {
            'auth-token': Cookies.get('customertoken'),
        }
    };

    function checkOpenWindowURLs(url) {
        // Strings to check for
        const stringsToCheck = ["query-information", "query-import-give-rate"];

        // Check if any of the strings are included in the URL
        return stringsToCheck.some((str) => url.includes(str));
    }
    const openNewWindow = (url) => {
        const newWindow = window.open(
            url, // URL of the new window
            '_blank', // Target window name
            'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1000,height=600' // Window features
        );

        const interval = setInterval(() => {
            if (newWindow.closed) {
                clearInterval(interval);
                // refreshData();
            }
        }, 500);
    };

    const readNotification = (id, url) => {
        try {

            axios.get(`${adminMainUrl}/api/customer/read-notifications?notification_id=${id}`, config)
                .then(res => {
                    if (res.status == 200) {
                        refreshNotification();
                        if (url) {
                            checkOpenWindowURLs(url) ?
                                openNewWindow(url)
                                :
                                navigate(url);
                        }
                    } else {
                        toast.error(res.data.msg);
                    }
                }).catch(err => {
                    console.log(err);
                    toast.error(err.response.data.msg);
                })
        } catch (error) {
            toast.error(error.message);
        }
    };

    const readAllNotifications = () => {
        try {
            axios.get(`${adminMainUrl}/api/customer/read-all-notifications`, config)
                .then(res => {
                    if (res.status == 200) {
                        refreshNotification();
                    } else {
                        toast.error(res.data.msg);
                    }
                }).catch(err => {
                    console.log(err);
                    toast.error(err.response.data.msg);
                })
        } catch (error) {
            toast.error(error.message);
        }
    }

    const deleteAllNotifications = () => {
        try {
            axios.get(`${adminMainUrl}/api/customer/delete-all-notifications`, config)
                .then(res => {
                    if (res.status == 200) {
                        refreshNotification();
                    } else {
                        toast.error(res.data.msg);
                    }
                }).catch(err => {
                    console.log(err);
                    toast.error(err.response.data.msg);
                })
        } catch (error) {
            toast.error(error.message);
        }
    }

    return (
        <>

            <div className="header">
                {/* Logo */}
                <div className="header-left active">
                    {/* <a href="#" className="logo logo-normal">
                        <img className="logo-side" src="/assets/img/logo.png" alt="" />
                    </a>
                    <a href="/flexichain/dashboard" className="logo-small">
                        <img src="/assets/img/logo-side.png" alt="Logo" />
                    </a>
                    <a id="toggle_btn" href="javascript:void(0);">
                        <i className="ti ti-arrow-bar-to-left" />
                    </a> */}

                    <a href="#" className="logo logo-normal">

                        {/* <img className="logo-side" src="/assets/img/logo-side.png" /> */}

                        <img className="logo-side company-logo-flexichain"
                            src={CompanyDetailData ? CompanyDetailData.logo_path : "/assets/img/logo.png"}
                            alt=""
                            onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = "/assets/img/logo.png";
                            }}
                        />

                        {/* <img src="./assets/img/logo.svg" alt="Logo" /> */}
                        <img
                            // src="/assets/img/white-logo.svg"
                            src={CompanyDetailData ? CompanyDetailData.logo_path : "/assets/img/white-logo.svg"}
                            className="white-logo"
                            alt="Logo"
                            onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = "/assets/img/logo.png";
                            }}
                        />
                    </a>
                    <a href="/flexichain/dashboard" className="logo-small company-logo-flexichain">
                        <img
                            src={CompanyDetailData ? CompanyDetailData.logo_path : "/assets/img/logo.png"}
                            alt="Logo"
                            onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = "/assets/img/logo.png";
                            }}
                        />
                    </a>
                    <a id="toggle_btn" href="javascript:void(0);">
                        <i className="ti ti-arrow-bar-to-left" />
                    </a>
                </div>
                {/* /Logo */}
                <a id="mobile_btn" className="mobile_btn" href="#sidebar">
                    <span className="bar-icon">
                        <span />
                        <span />
                        <span />
                    </span>
                </a>
                <div className="header-user">
                    <ul className="nav user-menu">
                        {/* Search */}
                        <li className="nav-item nav-search-inputs me-auto">
                            <div className="top-nav-search">
                                <a href="javascript:void(0);" className="responsive-search">
                                    <i className="fa fa-search" />
                                </a>
                            </div>
                        </li>
                        {/* /Search */}
                        {/* Nav List */}
                        <li className="nav-item nav-list">
                            <ul className="nav">
                                {/* <li className="dark-mode-list">
                                <a
                                    href="javascript:void(0);"
                                    id="dark-mode-toggle"
                                    className="dark-mode-toggle"
                                >
                                    <i className="ti ti-sun light-mode active" />
                                    <i className="ti ti-moon dark-mode" />
                                </a>
                            </li> */}
                                {/* <li className="nav-item dropdown">
                                    <a
                                        href="javascript:void(0);"
                                        className="btn btn-header-list"
                                        data-bs-toggle="dropdown"
                                    >
                                        <i className="ti ti-layout-grid-add" />
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-end menus-info">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <ul className="menu-list">
                                                    <li>
                                                        <a href="#">
                                                            <div className="menu-details">
                                                                <span className="menu-list-icon bg-violet">
                                                                    <i className="ti ti-user-up" />
                                                                </span>
                                                                <div className="menu-details-content">
                                                                    <p>Contacts</p>
                                                                    <span>Add New Contact</span>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#">
                                                            <div className="menu-details">
                                                                <span className="menu-list-icon bg-green">
                                                                    <i className="ti ti-timeline-event-exclamation" />
                                                                </span>
                                                                <div className="menu-details-content">
                                                                    <p>Pipline</p>
                                                                    <span>Add New Pipline</span>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#">
                                                            <div className="menu-details">
                                                                <span className="menu-list-icon bg-pink">
                                                                    <i className="ti ti-bounce-right" />
                                                                </span>
                                                                <div className="menu-details-content">
                                                                    <p>Activities</p>
                                                                    <span>Add New Activity</span>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#">
                                                            <div className="menu-details">
                                                                <span className="menu-list-icon bg-info">
                                                                    <i className="ti ti-analyze" />
                                                                </span>
                                                                <div className="menu-details-content">
                                                                    <p>Analytics</p>
                                                                    <span>Shows All Information</span>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#">
                                                            <div className="menu-details">
                                                                <span className="menu-list-icon bg-danger">
                                                                    <i className="ti ti-atom-2" />
                                                                </span>
                                                                <div className="menu-details-content">
                                                                    <p>Projects</p>
                                                                    <span>Add New Project</span>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="col-md-6">
                                                <ul className="menu-list">
                                                    <li>
                                                        <a href="#">
                                                            <div className="menu-details">
                                                                <span className="menu-list-icon bg-info">
                                                                    <i className="ti ti-medal" />
                                                                </span>
                                                                <div className="menu-details-content">
                                                                    <p>Deals</p>
                                                                    <span>Add New Deals</span>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#">
                                                            <div className="menu-details">
                                                                <span className="menu-list-icon bg-secondary">
                                                                    <i className="ti ti-chart-arcs" />
                                                                </span>
                                                                <div className="menu-details-content">
                                                                    <p>Leads</p>
                                                                    <span>Add New Leads</span>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#">
                                                            <div className="menu-details">
                                                                <span className="menu-list-icon bg-tertiary">
                                                                    <i className="ti ti-building-community" />
                                                                </span>
                                                                <div className="menu-details-content">
                                                                    <p>Company</p>
                                                                    <span>Add New Company</span>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#">
                                                            <div className="menu-details">
                                                                <span className="menu-list-icon bg-success">
                                                                    <i className="ti ti-list-check" />
                                                                </span>
                                                                <div className="menu-details-content">
                                                                    <p>Tasks</p>
                                                                    <span>Add New Task</span>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#">
                                                            <div className="menu-details">
                                                                <span className="menu-list-icon bg-purple">
                                                                    <i className="ti ti-brand-campaignmonitor" />
                                                                </span>
                                                                <div className="menu-details-content">
                                                                    <p>Campaign</p>
                                                                    <span>Add New Campaign</span>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </li> */}
                                {/* <li className="nav-item">
                                <a href="#" className="btn btn-help">
                                    <i className="ti ti-help-hexagon" />
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="#" className="btn btn-chart-pie">
                                    <i className="ti ti-chart-pie" />
                                </a>
                            </li> */}
                            </ul>
                        </li>
                        {/* /Nav List */}
                        {/* Email */}
                        {/* <li className="nav-item nav-item-email nav-item-box">
                        <a href="#">
                            <i className="ti ti-message-circle-exclamation" />
                            <span className="badge rounded-pill">14</span>
                        </a>
                    </li> */}
                        {/* /Email */}
                        {/* Notifications */}
                        <li className="nav-item dropdown nav-item-box">
                            <a
                                href="javascript:void(0);"
                                className="nav-link"
                                data-bs-toggle="dropdown"
                            >
                                <i className="ti ti-bell" />
                                <span className="badge rounded-pill">{notificationCount}</span>
                            </a>
                            <div className="dropdown-menu dropdown-menu-end notification-dropdown">
                                <div className="topnav-dropdown-header">
                                    <h4 className="notification-title">Notifications</h4>
                                </div>
                                <div className="noti-content">
                                    <ul className="notification-list">
                                        {notificationArr.length ?
                                            notificationArr.map((val, index) => {
                                                return <li className="notification-message" key={index + 1} onClick={() => { readNotification(val?.id, val?.redirect_url) }}>
                                                    <a href="#">
                                                        <div className="media d-flex">
                                                            <span className="avatar flex-shrink-0">
                                                                <img
                                                                    src="/assets/img/profiles/avatar-02.jpg"
                                                                    alt="Profile"
                                                                />
                                                                {val?.is_read === false && <span className="badge badge-info rounded-pill" />}
                                                            </span>
                                                            <div className="media-body flex-grow-1">
                                                                <p className="noti-details">
                                                                    {val?.notification}
                                                                </p>
                                                                <p className="noti-time">{AMPMDATETIME(val?.createdAt)}</p>

                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                            }) :
                                            <li className="notification-message">
                                                <a href="#">
                                                    <div className="media d-flex">
                                                        <span className="avatar flex-shrink-0">
                                                            <img
                                                                src="/assets/img/profiles/avatar-02.jpg"
                                                                alt="Profile"
                                                            />
                                                            {/* <span className="badge badge-info rounded-pill" /> */}
                                                        </span>
                                                        <div className="media-body flex-grow-1">
                                                            <p className="noti-details">
                                                                No new notifications.
                                                            </p>

                                                        </div>
                                                    </div>
                                                </a>
                                            </li>
                                        }
                                        {/* <li className="notification-message">
                                                               <a href="#">
                                                                   <div className="media d-flex">
                                                                       <span className="avatar flex-shrink-0">
                                                                           <img
                                                                               src="/assets/img/profiles/avatar-02.jpg"
                                                                               alt="Profile"
                                                                           />
                                                                           <span className="badge badge-info rounded-pill" />
                                                                       </span>
                                                                       <div className="media-body flex-grow-1">
                                                                           <p className="noti-details">
                                                                               Ray Arnold left 6 comments on Isla Nublar SOC2
                                                                               compliance report
                                                                           </p>
                                                                           <p className="noti-time">Last Wednesday at 9:42 am</p>
                                                                       </div>
                                                                   </div>
                                                               </a>
                                                           </li>
                                                           <li className="notification-message">
                                                               <a href="#">
                                                                   <div className="media d-flex">
                                                                       <span className="avatar flex-shrink-0">
                                                                           <img
                                                                               src="/assets/img/profiles/avatar-03.jpg"
                                                                               alt="Profile"
                                                                           />
                                                                       </span>
                                                                       <div className="media-body flex-grow-1">
                                                                           <p className="noti-details">
                                                                               Denise Nedry replied to Anna Srzand
                                                                           </p>
                                                                           <p className="noti-sub-details">
                                                                               “Oh, I finished de-bugging the phones, but the
                                                                               system's compiling for eighteen minutes, or twenty.
                                                                               So, some minor systems may go on and off for a while.”
                                                                           </p>
                                                                           <p className="noti-time">Last Wednesday at 9:42 am</p>
                                                                       </div>
                                                                   </div>
                                                               </a>
                                                           </li>
                                                           <li className="notification-message">
                                                               <a href="#">
                                                                   <div className="media d-flex">
                                                                       <span className="avatar flex-shrink-0">
                                                                           <img alt="" src="/assets/img/profiles/avatar-06.jpg" />
                                                                       </span>
                                                                       <div className="media-body flex-grow-1">
                                                                           <p className="noti-details">
                                                                               John Hammond attached a file to Isla Nublar SOC2
                                                                               compliance report
                                                                           </p>
                                                                           <div className="noti-pdf">
                                                                               <div className="noti-pdf-icon">
                                                                                   <span>
                                                                                       <i className="ti ti-chart-pie" />
                                                                                   </span>
                                                                               </div>
                                                                               <div className="noti-pdf-text">
                                                                                   <p>EY_review.pdf</p>
                                                                                   <span>2mb</span>
                                                                               </div>
                                                                           </div>
                                                                           <p className="noti-time">Last Wednesday at 9:42 am</p>
                                                                       </div>
                                                                   </div>
                                                               </a>
                                                           </li> */}
                                    </ul>
                                </div>
                                <div className="topnav-dropdown-footer">
                                    <button className="view-link me-1" onClick={() => { readAllNotifications() }} style={{ border: "none" }}>
                                        Read all
                                    </button>
                                    <button href="javascript:void(0);" className="clear-link ms-1" onClick={() => { deleteAllNotifications() }} style={{ border: "none" }}>
                                        Clear all
                                    </button>
                                </div>
                            </div>
                        </li>
                        {/* /Notifications */}
                        {/* Profile Dropdown */}
                        <li className="nav-item dropdown has-arrow main-drop">
                            <a
                                // href="javascript:void(0);"
                                className="nav-link userset"
                                data-bs-toggle="dropdown"
                            >
                                <span className="user-info">
                                    <span className="user-letter">
                                        <img src="/assets/img/profiles/avatar-20.jpg" alt="Profile" />
                                    </span>
                                    <span className="badge badge-success rounded-pill" />
                                </span>
                            </a>
                            <div className={`dropdown-menu menu-drop-user `}>
                                <div className="profilename">
                                    {/* <Link className="dropdown-item" to="/customer-dashboard/dashboard">
                                        <i className="ti ti-layout-2" /> Dashboard
                                    </Link>
                                    <Link className="dropdown-item" to="/customer-dashboard/profile">
                                        <i className="ti ti-user-pin" /> My Profile
                                    </Link> */}
                                    <a className="dropdown-item" onClick={handleLogout}>
                                        <i className="ti ti-lock" /> Logout
                                    </a>
                                </div>
                            </div>
                        </li>
                        {/* /Profile Dropdown */}
                    </ul>
                </div>
                {/* Mobile Menu */}
                <div className="dropdown mobile-user-menu">
                    <a
                        href="javascript:void(0);"
                        className="nav-link dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <i className="fa fa-ellipsis-v" />
                    </a>
                    <div className="dropdown-menu">
                        <a className="dropdown-item" href="index.html">
                            <i className="ti ti-layout-2" /> Dashboard
                        </a>
                        <a className="dropdown-item" href="profile.html">
                            <i className="ti ti-user-pin" /> My Profile
                        </a>
                        <a className="dropdown-item" href="login.html">
                            <i className="ti ti-lock" /> Logout
                        </a>
                    </div>
                </div>
                {/* /Mobile Menu */}
            </div>
        </>
    )
}

export default Navbar